const getWorkflowFormValues = ({ fields = [], object = {}, changes = {} }) => ({
  ...Object.fromEntries(
    fields.map(field => [
      field.name,
      Object.prototype.hasOwnProperty.call(field, "value") ? field.value : object[field.name],
    ]),
  ),
  ...changes,
});

const validateWorkflowField = ({ field, value, messages }) => {
  const selectedValue = field.type === "select" && value && typeof value === "object" ? value.id : value;
  const empty =
    value === undefined ||
    value === null ||
    value === "" ||
    (field.type === "float" && Number.isNaN(value)) ||
    (field.type === "select" &&
      (field.multiple
        ? !Array.isArray(value) || value.length === 0
        : selectedValue === undefined || selectedValue === null || selectedValue === ""));

  if (empty) return field.require ?? field.required ? messages.not_empty : "";

  if (field.type === "float") {
    if (field.options?.min !== undefined && Number(value) < field.options.min) {
      return `${messages.should_be_greater} ${field.options.min}`;
    }

    if (field.options?.max !== undefined && Number(value) > field.options.max) {
      return `${messages.should_be_less} ${field.options.max}`;
    }
  }

  return "";
};

const validateWorkflowForm = ({ fields = [], values, messages }) =>
  fields.reduce((errors, field) => {
    const message = validateWorkflowField({ field, value: values[field.name], messages });

    if (message) errors[field.name] = message;

    return errors;
  }, {});

module.exports = {
  getWorkflowFormValues,
  validateWorkflowField,
  validateWorkflowForm,
};
